import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { SUBSCRIPTIONS } from '@/app/modules/subscriptions/api/apiUrls';

const mutationAddEnvelope = (onSuccess, onError) => {
    return {
        mutationFn: ({ subscriptionId, downloadCodeUuid }) => {
            return client.post(
                replaceParameters(SUBSCRIPTIONS.CREATE_ENVELOPE.url, { subscriptionId: subscriptionId }),
                { downloadCodeUuid }
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAddEnvelope;